import { LazyImage } from "../../controls/LazyImage";
import { PageTitle } from "../../controls/PageTitle";
import { PageWrapper } from "../../controls/PageWrapper";

export function Dashboard(props: {}) {
    return (
        <PageWrapper>
            <PageTitle title="ModelTransformer: Start coding by importing" />
            <div style={{ padding: 24, minHeight: 360, backgroundColor: "#fff" }}>
                <LazyImage src="/idea.webp" />
            </div>
        </PageWrapper>
    );
};
